import { render, staticRenderFns } from "./UsageSidePanel.vue?vue&type=template&id=4c6a9b0e&"
import script from "./UsageSidePanel.vue?vue&type=script&lang=ts&"
export * from "./UsageSidePanel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports